export default "__VITE_ASSET__eQwXm$c1__"